import { ContactModalContent } from 'components/contact/contactNotificationModal/ContactModalContent'
import { useActualContact } from 'components/contact/contactUtils'
import { ApiType } from 'utils/types'

//
// This modal is used for:
// - telling an existing user that they have just accepted the TC invite from a ContactCard
//

export const ContactAcceptModal = (props: {
  contact?: ApiType['TrustedContactResponse']
  type?: ApiType['TrustedContactUserResponse']['type']
}) => {
  const { actualContact } = useActualContact(props.contact)

  const contactName = actualContact?.first_name || actualContact?.email
  const isLegacy = actualContact?.user?.type === 'LEGACY_CONTACT'
  return (
    <ContactModalContent
      actualContact={actualContact}
      topTitleText={`You accepted ${isLegacy ? 'Legacy Contact' : 'Trusted Contact'} invite`}
      titleText={`Great news! ${
        isLegacy
          ? `You became ${contactName}'s Legacy Contact.`
          : `You and ${contactName} became Trusted Contacts on GoodTrust.`
      }`}
      descriptionText={
        isLegacy
          ? `Well done! You've completed an important step in your GoodTrust journey. A Legacy Contact means someone can take action on your behalf and ensure your digital accounts and content is managed in the manner you choose.`
          : `Nice work! Having at least one Trusted Contact means your GoodTrust account will not be lost forever and your wishes can be fulfilled. You can choose to share content now, never, or only after you pass away. You decide.`
      }
    />
  )
}
